export function mergeAssistReviewers(existing: string[], pending: string): string[] {
    const next: string[] = [];
    const seen = new Set<string>();
    for (const raw of [...existing, pending]) {
        const trimmed = raw.trim();
        if (!trimmed) {
            continue;
        }
        const key = trimmed.toLowerCase();
        if (seen.has(key)) {
            continue;
        }
        seen.add(key);
        next.push(trimmed);
    }
    return next;
}

export function assistAccessNotice(hidden: boolean, reviewers: string[]): string {
    if (!hidden) {
        return "Polaris Assist is available to everyone in this organisation.";
    }
    if (reviewers.length === 0) {
        return "Polaris Assist is hidden from this organisation.";
    }
    if (reviewers.length === 1) {
        return "Polaris Assist is hidden, except for the reviewer you listed.";
    }
    return "Polaris Assist is hidden, except for the reviewers you listed.";
}
